import * as React from 'react';
import { StoresContext } from './StoresContext';
import RootStore from 'src/stores/RootStore';

function useStores(): RootStore {
  return React.useContext(StoresContext);
}

export default useStores;
